import { z } from 'zod'
import { DiscountType } from '../types/discount.types'
import { RawBuyoverDataSchema } from 'features/cart/buyoverTiers'

const OfferedDiscountBaseSchema = z.object({
  discountId: z.string().optional(),
  promocode: z.string().optional(),
  popular: z.boolean().optional(),
  isAutomatic: z.boolean().optional(),
})

const PercentDiscountSchema = OfferedDiscountBaseSchema.extend({
  type: z.literal(DiscountType.PERCENT),
  percentageData: z.object({ percentOff: z.number() }),
})

const BundleDiscountSchema = OfferedDiscountBaseSchema.extend({
  type: z.literal(DiscountType.BUNDLE),
  bundleData: z.object({ quantity: z.number(), price: z.number() }),
})

const BuyXGetYDiscountSchema = OfferedDiscountBaseSchema.extend({
  type: z.literal(DiscountType.BUYXGETY),
  buyXGetYData: z.object({ buy: z.number(), get: z.number() }),
})

const BuyoverDiscountSchema = OfferedDiscountBaseSchema.extend({
  type: z.literal(DiscountType.BUYOVER),
  buyOverData: RawBuyoverDataSchema,
})

export const OfferedDiscountSchema = z.discriminatedUnion('type', [
  PercentDiscountSchema,
  BundleDiscountSchema,
  BuyXGetYDiscountSchema,
  BuyoverDiscountSchema,
])

export type OfferedDiscount = z.infer<typeof OfferedDiscountSchema>
